import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.scss";
import authService from "../../services/auth-service";
import { updateDBHeaders } from "../../db/pouchdb-config";
import wsService from "../../services/websocket-service";

function Login(props) {
  let [uname, setUname] = useState("");
  let [password, setPass] = useState("");
  let [error, setError] = useState("");
  let [isGoogleLoading, setIsGoogleLoading] = useState(false);
  let [loginType, setLoginType] = useState('phone'); // 'phone' or 'email'
  const navigate = useNavigate();

  async function handleGoogleLogin() {
    setIsGoogleLoading(true);
    setError("");
    
    try {
      const result = await authService.loginWithGoogle();
      
      if (result.user) {
        console.log("Logged in with Google successfully", result);
        sessionStorage.setItem("isUserAuthenticated", "true");
        const isAdmin = result.user.isAdmin;
        sessionStorage.setItem("customerId", result.user.id);
        sessionStorage.setItem("customerEmail", result.user.email);
        sessionStorage.setItem("customerName", `${result.user.fname} ${result.user.lname}`.trim());
        sessionStorage.setItem("isAdmin", isAdmin ? "true" : "false");
        sessionStorage.setItem("jwt_token", result.token);
        sessionStorage.setItem("jwt_refresh_token", result.refreshToken);
        props.setUserAuthenticatedStatus(isAdmin ? true : false, result.user.id);
        
        // Redirect based on user role
        if (isAdmin) {
          navigate("/admin");
        } else {
          navigate("/customer");
        }
      }
    } catch (err) {
      console.log(err);
      setError(err.message || "Google login failed");
    } finally {
      setIsGoogleLoading(false);
    }
  }

  async function handleClick() {
    if (validateInputs()) {
      try {
        // Use phone login only
        const result = await authService.login(uname, password, 'phone');
        updateDBHeaders(); // Update PouchDB headers with token
        sessionStorage.setItem("isUserAuthenticated", "true");
        const isAdmin = result.user.role === 'admin';
        sessionStorage.setItem("customerId", result.user.id);
        sessionStorage.setItem("customerEmail", result.user.email);
        sessionStorage.setItem("customerName", result.user.name);
        sessionStorage.setItem("customerPhone", uname);
        sessionStorage.setItem("isAdmin", String(isAdmin));
        sessionStorage.removeItem("trialJustClaimed");
        sessionStorage.removeItem("hasSubscriptions");
        props.setUserAuthenticatedStatus(isAdmin, result.user.id);
        
        // Connect WebSocket for real-time updates
        wsService.connect();
        
        // Trigger cart update after login
        setTimeout(() => {
          const event = new CustomEvent('cartUpdated');
          window.dispatchEvent(event);
        }, 100);
        
        // Redirect based on user role
        if (isAdmin) {
          navigate("/admin");
        } else {
          navigate("/customer");
        }
      } catch (err) {
        console.log(err);
        setError(err.message || "Login failed");
      }
    }
  }

  function validateEmail(email) {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  }

  function validatePhone(phone) {
    // Indian phone number validation (10 digits, optional +91)
    const regex = /^(\+91)?[6-9]\d{9}$/;
    return regex.test(phone.replace(/\s+/g, ''));
  }

  function validatePassword(password) {
    return password.length >= 6;
  }

  function validateInputs() {
    if (!validatePhone(uname)) {
      setError("Please provide a valid phone number (10 digits).");
      return false;
    }
    
    if (!validatePassword(password)) {
      setError("Password must be at least 6 characters long.");
      return false;
    }
    setError("");
    return true;
  }

  function changeName(event) {
    const value = event.target.value;
    setUname(value);
    // Phone login only - no auto-detection needed
  }

  function changePass(event) {
    setPass(event.target.value);
  }

  function handleKeyPress(event) {
    if (event.key === 'Enter') {
      handleClick();
    }
  }

  return (
    <>
      <div className="login-container">
        <h1>Login</h1>
        {/* Radio buttons hidden - phone login only */}
        {/* <div className="login-type-selector">
          <div className="radio-group">
            <label className="radio-option">
              <input 
                type="radio" 
                name="loginType" 
                value="phone" 
                checked={loginType === 'phone'}
                onChange={(e) => setLoginType(e.target.value)}
              />
              <span>Phone</span>
            </label>
            <label className="radio-option">
              <input 
                type="radio" 
                name="loginType" 
                value="email" 
                checked={loginType === 'email'}
                onChange={(e) => setLoginType(e.target.value)}
              />
              <span>Email</span>
            </label>
          </div>
        </div> */}
        <div>
          <label>Phone Number</label>
          <input 
            type="tel" 
            name="username"
            autoComplete="username"
            value={uname} 
            onChange={changeName}
            onKeyPress={handleKeyPress}
            placeholder="Enter your phone number"
          ></input>
        </div>
        <div>
          <label>Password</label>
          <input
            type="password"
            name="password"
            autoComplete="current-password"
            value={password}
            onChange={changePass}
            onKeyPress={handleKeyPress}
          ></input>
        </div>
        {error && <div className="error-message">{error}</div>}
        <button onClick={handleClick}>Login</button>
        
        {/* Google login hidden - phone number required */}
        {/* <div className="divider">
          <span>OR</span>
        </div>
        
        <button 
          className="google-login-button" 
          onClick={handleGoogleLogin}
          disabled={isGoogleLoading}
        >
          {isGoogleLoading ? (
            <span>Signing in...</span>
          ) : (
            <>
              <svg className="google-icon" viewBox="0 0 24 24" width="18" height="18">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
              </svg>
              Continue with Google
            </>
          )}
        </button> */}
        <div className="links-container">
          <div className="register-link" onClick={() => props.navigateToRegisterPage()}>
            Is New User
          </div>
          <div className="forgot-password-link" onClick={() => props.navigateToForgotPasswordPage()}>
            Forgot Password?
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;